import React from 'react'
import Navbar from './Navbar'

const Certifications = () => {
    return (
        <section className="resume-section" id="certifications">
            <Navbar />
            <div className="resume-section-content">
                <h2 className="mb-5">Certifications</h2>
                <ul className="fa-ul mb-0">
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        <a href="https://www.coursera.org/account/accomplishments/certificate/RJBAVG39NSG5">
                            Front-End Web Development with React
                        </a>
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        <a href="https://www.coursera.org/account/accomplishments/verify/5KE28VQ3CUY7">
                            Server-side Development with NodeJS, Express and MongoDB
                        </a>
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        <a href="https://www.coursera.org/account/accomplishments/certificate/VAXWQU6J98QV">
                            Version Control with Git
                        </a>
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        <a href="https://www.coursera.org/account/accomplishments/certificate/CRBT7T65RT4P">
                            Interactivity with JavaScript
                        </a>
                    </li>

                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        <a href="https://www.coursera.org/account/accomplishments/certificate/T5LVJFPB9Y8Z">
                            HTML, CSS, and Javascript for Web Developers
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Certifications
